import React, { useEffect, useState } from "react";
import axios from 'axios';
import { useSidebar } from "../../SidebarContext";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom"
import Select from "react-select";
// import Select from "react-select";

const steps = ["Upload videos", "Details"];

const ConfirmUserModal = ({ isOpen, onYes, onNo }) => {
    if (!isOpen) return null;

    return (
        <div className="addvideomodal-overlay">
            <div className="addvideomodal-content">
                <h2 className="addvideomodal-title">Have you created the user for this video?</h2>
                <div className="addvideomodal-actions">
                    <button className="addvideomodal-btn no-btn" onClick={onNo}>No</button>
                    <button className="addvideomodal-btn yes-btn" onClick={onYes}>Yes</button>
                </div>
            </div>
        </div>
    );
};



const VideoUploadForm = () => {
    const { isSidebarOpen } = useSidebar();
    const [step, setStep] = useState(1);
    const [video, setVideo] = useState(null);
    const [videoFile, setVideoFile] = useState(null);
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [thumbnail, setThumbnail] = useState(null);
    const [thumbnailFile, setThumbnailFile] = useState(null);
    const [audience, setAudience] = useState("no");
    const [tags, setTags] = useState([]);
    const [tagInput, setTagInput] = useState("");
    const [category, setCategory] = useState("People & Blogs");
    const [type, setType] = useState("Long Video");
    const [uploading, setUploading] = useState(false);
    const [progress, setProgress] = useState(0);
    const [employees, setEmployees] = useState([]);
    const [options, setOptions] = useState([]);
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const totalChars = tags.join("").length;
    const [events, setEvents] = useState([]);
    const [selectedEvent, setSelectedEvent] = useState(null);
    const navigate = useNavigate()
    const url = process.env.REACT_APP_LINK
    const [isConfirmed, setIsConfirmed] = useState(false);
    const [showConfirmModal, setShowConfirmModal] = useState(true); // show modal immediately on Step 1



    const handleTagKeyDown = (e) => {
        if (e.key === "," || e.key === "Enter") {
            e.preventDefault();
            const newTag = tagInput.trim();
            if (newTag && !tags.includes(newTag) && totalChars + newTag.length <= 500) {
                setTags([...tags, newTag]);
                setTagInput("");
            }
        }
    };

    const removeTag = (tagToRemove) => {
        setTags(tags.filter((tag) => tag !== tagToRemove));
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setVideo(URL.createObjectURL(file));
            setVideoFile(file);
            setStep(2);
        }
    };

    const handleThumbnailChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setThumbnail(URL.createObjectURL(file));
            setThumbnailFile(file);
        }
    };

    const handlePublish = async () => {
        if (!videoFile) {
            alert("Please upload a video");
            return;
        }

        setUploading(true);
        setProgress(0);

        try {
            const formData = new FormData();
            formData.append("title", title);
            formData.append("description", description);
            formData.append("category", category);
            formData.append("audience", audience);
            formData.append("tags", JSON.stringify(tags));
            formData.append("video", videoFile);
            formData.append("user_id", selectedEmployee);
            formData.append("type", type);
            if (thumbnailFile) {
                formData.append("thumbnail_path", thumbnailFile);
            }

            const res = await axios.post(`${url}/api/videos/upload-admin`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            const { uploadId } = res.data;
            const eventSource = new EventSource(`${url}/api/videos/progress/${uploadId}`);

            eventSource.onmessage = (e) => {
                const data = JSON.parse(e.data);
                setProgress(data.progress);

                if (data.progress >= 100) {
                    eventSource.close();
                    toast.success("video uploaded successfully");
                    navigate('/content')
                    // alert("Video uploaded successfully!");
                }
            };
        } catch (error) {
            console.error(error);
            alert("Upload failed");
        }
    };

    const fetchUsers = async () => {
        try {
            const response = await fetch(`${url}/api/user/admin1997`);
            const data = await response.json();
            setEmployees(data)
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };



    useEffect(() => {
        fetchUsers();

    }, [])

    return (
        <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
            <div className="articles-impact">
                <h1 className="dashboard-title">Publish Video</h1>
            </div>
            <div className="upload-container">
                {/* Stepper */}
                <div className="stepper">
                    {steps.map((label, idx) => (
                        <div
                            key={idx}
                            className={`step ${idx + 1 === step
                                ? "active-step"
                                : idx + 1 < step
                                    ? "completed-step"
                                    : "upcoming-step"
                                }`}
                        >
                            {label}
                            {idx < steps.length - 1 && <span className="step-divider"></span>}
                        </div>
                    ))}
                </div>

                {/* Body */}
                <div className="upload-body">
                    {/* {step === 1 && (
                        <div className="upload-dropzone">
                            <div className="upload-dropzone-inner">
                                <div className="upload-icon">⬆️</div>
                               
                                <p className="upload-subtext">Your videos will be private until you publish them</p>
                                <label className="upload-button">
                                    Select files
                                    <input type="file" accept="video/*" className="hidden" onChange={handleFileChange} />
                                </label>
                            </div>
                        </div>
                    )} */}

                    {step === 1 && (
                        <>
                            {!isConfirmed ? (
                                <ConfirmUserModal
                                    isOpen={showConfirmModal}
                                    onYes={() => {
                                        setIsConfirmed(true);
                                        setShowConfirmModal(false);
                                    }}
                                    onNo={() => {
                                        setShowConfirmModal(false);
                                        navigate("/all-users");
                                    }}
                                />
                            ) : (
                                <div className="upload-dropzone">
                                    <div className="upload-dropzone-inner">
                                        <div className="upload-icon">⬆️</div>
                                        <p className="upload-subtext">Your videos will be private until you publish them</p>
                                        <label className="upload-button">
                                            Select files
                                            <input type="file" accept="video/*" className="hidden" onChange={handleFileChange} />
                                        </label>
                                    </div>
                                </div>
                            )}
                        </>
                    )}


                    {step === 2 && (
                        <div className="upload-details">
                            <div className="details-left">
                                <div className="form-group">
                                    <label>Video Type</label>
                                    {/* <p className="hint">Add your video to a category so viewers can find it more easily</p> */}
                                    <select value={type} onChange={(e) => setType(e.target.value)} className="select-input">
                                        <option value="">Select Type</option>
                                        <option value="Short Video">Short Video</option>
                                        <option value="Long Video">Long Video</option>
                                    </select>
                                </div>
                                {/* Title */}
                                <div className="form-group">
                                    <label>Title <span className="hint">(required)</span></label>
                                    <div className="input-wrapper">
                                        <input
                                            type="text"
                                            value={title}
                                            onChange={(e) => setTitle(e.target.value)}
                                            placeholder="Enter your video title"
                                            maxLength={100}
                                            className="text-input"
                                        />
                                        <span className="char-count">{title.length}/100</span>
                                    </div>
                                </div>

                                {/* Description */}
                                <div className="form-group">
                                    <label>Description</label>
                                    <textarea
                                        value={description}
                                        onChange={(e) => setDescription(e.target.value)}
                                        placeholder="Tell viewers about your video"
                                        rows="4"
                                        className="text-area"
                                    />
                                </div>

                                {/* Thumbnail */}
                                <div className="form-group">
                                    <label>Thumbnail</label>
                                    <div className="thumbnail-box">
                                        {thumbnail ? (
                                            <img src={thumbnail} alt="Thumbnail" className="thumbnail-preview" />
                                        ) : (
                                            <p className="upload-subtext">No thumbnail uploaded</p>
                                        )}
                                        <label className="upload-button">
                                            Upload image
                                            <input type="file" accept="image/*" className="hidden" onChange={handleThumbnailChange} />
                                        </label>
                                    </div>
                                </div>

                                {/* Audience */}
                                <div className="audience-box">
                                    <p className="audience-title">Audience</p>
                                    <p className="audience-subtext">
                                        You're required to tell us whether your videos are made for kids.{" "}
                                        <a href="#" className="link">What's content made for kids?</a>
                                    </p>
                                    <label><input type="radio" name="audience" value="yes" checked={audience === "yes"} onChange={() => setAudience("yes")} /> Yes, it's made for kids</label>
                                    <label><input type="radio" name="audience" value="no" checked={audience === "no"} onChange={() => setAudience("no")} /> No, it's not made for kids</label>
                                </div>

                                {/* <div className="form-group">
                                    <label>Video Type</label>
                                   
                                    <select value={type} onChange={(e) => setType(e.target.value)} className="select-input">
                                        <option value="">Select Type</option>
                                        <option value="Short Video">Short Video</option>
                                        <option value="Long Video">Long Video</option>
                                        
                                    </select>
                                </div> */}
                                {/* Tags */}
                                <div className="form-group">
                                    <label>Tags</label>
                                    <div className="tags-box">
                                        {tags.map((tag, idx) => (
                                            <span key={idx} className="tag">
                                                {tag}
                                                <button type="button" onClick={() => removeTag(tag)}>×</button>
                                            </span>
                                        ))}
                                        <input
                                            type="text"
                                            value={tagInput}
                                            onChange={(e) => setTagInput(e.target.value)}
                                            onKeyDown={handleTagKeyDown}
                                            placeholder="Enter a comma after each tag"
                                            className="tag-input"
                                        />
                                    </div>
                                    <p className="tag-counter">{totalChars}/500</p>
                                </div>

                                {/* Category */}
                                <div className="form-group">
                                    <label>Category</label>
                                    <p className="hint">Add your video to a category so viewers can find it more easily</p>
                                    <select value={category} onChange={(e) => setCategory(e.target.value)} className="select-input">
                                        <option value="People & Blogs">People & Blogs</option>
                                        <option value="Education">Education</option>
                                        <option value="Entertainment">Entertainment</option>
                                        <option value="Music">Music</option>
                                        <option value="Sports">Sports</option>
                                        <option value="Gaming">Gaming</option>
                                        <option value="News & Politics">News & Politics</option>
                                        <option value="Science & Technology">Science & Technology</option>
                                        <option value="Travel & Events">Travel & Events</option>
                                        <option value="Comedy">Comedy</option>
                                        <option value="Film & Animation">Film & Animation</option>
                                        <option value="Howto & Style">Howto & Style</option>
                                        <option value="Pets & Animals">Pets & Animals</option>
                                        <option value="Autos & Vehicles">Autos & Vehicles</option>
                                        <option value="Nonprofits & Activism">Nonprofits & Activism</option>
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label>User</label>
                                    <Select
                                        options={employees.map((employee) => ({
                                            value: employee.user_id,
                                            label: `${employee.full_name} (${employee.user_id})`,
                                        }))}
                                        value={
                                            employees
                                                .map((employee) => ({
                                                    value: employee.user_id,
                                                    label: `${employee.full_name} (${employee.user_id})`,
                                                }))
                                                .find((option) => option.value === selectedEmployee) || null
                                        }
                                        onChange={(selectedOption) =>
                                            setSelectedEmployee(selectedOption ? selectedOption.value : "")
                                        }
                                        placeholder="Select User"
                                        menuPlacement="top"
                                        isClearable
                                        styles={{
                                            container: (base) => ({
                                                ...base,
                                                marginTop: '1px', 
                                            }),
                                        }}
                                    />
                                </div>
                            </div>

                            {/* Right Side */}
                            <div className="details-right">
                                {video ? (
                                    <video src={video} controls className="video-preview" />
                                ) : (
                                    <div className="video-placeholder">No video uploaded</div>
                                )}
                                <p className="hint">Video link will appear here</p>
                            </div>
                        </div>
                    )}
                </div>

                {/* Footer */}
                <div className="footer">
                    {step > 1 && <button onClick={() => setStep(step - 1)} className="secondary-btn">Back</button>}
                    {step < steps.length ? (
                        <button onClick={() => setStep(step + 1)} className="primary-btn">Next</button>
                    ) : (
                        <button onClick={handlePublish} disabled={uploading} className="primary-btn">
                            {uploading ? `Uploading... ${progress}%` : "Publish"}
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default VideoUploadForm;
